import { FaireLogo } from "@faire/web/slate/logos/FaireLogo";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";

const SEOSectionText = styled(Typography).attrs({
  variant: "pageHeaderSerifRegular",
})`
  max-width: 368px;
  ${responsiveMediaQueries.tablet} {
    max-width: 340px;
  }
`;

export const FooterSEOText: React.FC = () => {
  return (
    <>
      <FaireLogo size={128} />
      <Spacer size={32} />
      <SEOSectionText>
        <StrictLocalMsg
          defaultMessage="The online wholesale marketplace connecting independent retailers and brands around the world"
          description={{ text: "line describing what Faire does" }}
        />
      </SEOSectionText>
    </>
  );
};
